import { List } from 'immutable';
import { Themes } from 'records/Theme';
import BaseList from 'records/BaseList';

import {
  THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_START,
  THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_SUCCESS,
  THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_ERROR,
  THEMES_GRAPHIC_CATEGORY_RESET_STATE,
} from 'actions/themesGraphicCategory';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const themesGraphicCategoryData = Themes(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: themesGraphicCategoryData,
    });
  },
  [THEMES_GRAPHIC_CATEGORY_RESET_STATE]: () => {
    return initialState;
  },
};

export default function themesGraphicCategory(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
